import React, { type FunctionComponent } from "react";
import { Alert, Form, Input } from "antd";
import { type FormInstance } from "antd/lib/form/Form";
import { useTranslation } from "react-i18next";

import { type FreshMailIntegrationFormModel } from "./types";

interface OwnProps {
  formController?: FormInstance<FreshMailIntegrationFormModel>;
  onSubmit: (formData: FreshMailIntegrationFormModel) => void;
  model?: FreshMailIntegrationFormModel | null;
}

type Props = OwnProps;

const FreshMailIntegrationForm: FunctionComponent<Props> = ({ formController, onSubmit, model }) => {
  const { t } = useTranslation(["settings", "common"]);
  return (
    <div className="min-w-[450px]">
      <Form<FreshMailIntegrationFormModel>
        name="fresh-mail-form"
        layout="vertical"
        form={formController}
        onFinish={onSubmit}
        initialValues={{
          url: model?.url ?? "",
          firstNameKey: t<string>("common:firstNameKey"),
          lastNameKey: t<string>("common:lastNameKey"),
        }}
        size="large"
        validateTrigger={["onSubmit"]}
      >
        <Form.Item
          name="url"
          label={t("freshMailForm.url")}
          tooltip={t("freshMailForm.accountNamePlaceholder")}
          rules={[
            {
              required: true,
              message: t<string>("common:validationErrors.fieldIsRequired"),
            },
          ]}
        >
          <Input autoFocus={!model} disabled={!!model?.url} />
        </Form.Item>

        <Form.Item
          name="apiKey"
          tooltip={t("freshMailForm.tooltip")}
          label={t("freshMailForm.apiKey")}
          rules={[
            {
              required: true,
              message: t<string>("common:validationErrors.fieldIsRequired"),
            },
          ]}
        >
          <Input autoFocus={!!model} />
        </Form.Item>

        <Form.Item
          name="firstNameKey"
          label={t("freshMailForm.firstNameKey")}
          rules={[
            {
              required: true,
              message: t<string>("common:validationErrors.fieldIsRequired"),
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="lastNameKey"
          label={t("freshMailForm.lastNameKey")}
          rules={[
            {
              required: true,
              message: t<string>("common:validationErrors.fieldIsRequired"),
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>

      <Alert showIcon message={t("freshMailForm.defaultFieldsInfo")} />
    </div>
  );
};

export default FreshMailIntegrationForm;
